<error-dialog [error]="errorText" [show]="errorDialog"/>
<breadcrumb endText="Subject List" />
<!-- TODO need to create side search/filter, should be a reusable component -->
<div [ngClass]="isOpened? 'border-l p-3 flex flex-col fixed right-0 h-screen lg:w-[225px] w-[190px]' : 'border-l p-3 flex flex-col right-0 fixed h-screen'">
  <div>
    Search and Filter
  </div>
  <hr class="mb-3 mt-1 -mx-3" />
  <div class="flex input">
    <fa-icon [icon]="faMagnifyingGlass" [style]="primaryColor" />
    <input type="text" class="flex-grow w-full border-0 bg-[#F6F7F8] outline-none text-xs" placeholder="Search" [(ngModel)]="searchText" />
  </div>
</div>
<div [ngClass]="isOpened? 'm-8 lg:mr-[225px] mr-[190px]' : 'm-8 mr-[68px]'">
  <h1 class="font-medium text-xl mb-2">
    Subject List
  </h1>
  <hr class="mb-6" />
  @if (!isLoading) {
    <div>
      @for (subject of subjects; track subject) {
        <div class="mr-2 mb-1">
          @if (subject.name.includes(searchText)) {
            <button (click)="subjectClick(subject.subject_id)" class="flex justify-between w-full px-3 py-2 hover:bg-gray-200 rounded-lg">
              <div>
                {{subject.name}}
              </div>
              <fa-icon [icon]="faChevronRight" />
            </button>
          }
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <div class="mr-2">
      <div class="w-full px-3 py-2 animate-pulse bg-gray-100 rounded-lg h-10 mb-1"></div>
      <div class="w-full px-3 py-2 animate-pulse bg-gray-100 rounded-lg h-10 mb-1"></div>
      <div class="w-full px-3 py-2 animate-pulse bg-gray-100 rounded-lg h-10 mb-1"></div>
    </div>
  }
</div>
